import React from 'react';

const Moon = props => (
  <svg viewBox="0 0 23 28" width="1em" height="1em" {...props}>
    <path d="M19.719 20.359c-.562.094-1.141.141-1.719.141-5.797 0-10.5-4.703-10.5-10.5 0-1.984.578-3.922 1.625-5.578A9.952 9.952 0 0 0 2 14c0 5.516 4.484 10 10 10 3.016 0 5.844-1.375 7.719-3.641zm3.172-1.328A12.035 12.035 0 0 1 12 26C5.391 26 0 20.609 0 14A11.95 11.95 0 0 1 11.547 2.016a.976.976 0 0 1 .953.609c.172.391.063.844-.234 1.125A8.372 8.372 0 0 0 9.5 10c0 4.688 3.813 8.5 8.5 8.5a8.352 8.352 0 0 0 3.563-.797 1 1 0 0 1 1.328 1.328z" />
  </svg>
);

export default Moon;
